export const GLOBAL_DATA_STALE_TIME = 5 * 60 * 1000; // 5 minutes
export const BASE_NAME = process.env.PUBLIC_URL?.match(/\/pr\/\d+/)?.[0];
